import { AbpHttpInterceptor, RefreshTokenService, AbpHttpConfigurationService } from 'abp-ng2-module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import * as ApiServiceProxies from './service-proxies';
import { ZeroRefreshTokenService } from '@account/auth/zero-refresh-token.service';
import { ZeroTemplateHttpConfigurationService } from './zero-template-http-configuration.service';

@NgModule({
    providers: [
        ApiServiceProxies.SyncLatestDataServiceProxy,
        ApiServiceProxies.GridFeatureUsageTrackerServiceProxy,
        ApiServiceProxies.DynamicPageStateServiceProxy,
        ApiServiceProxies.DynamicGridStateServiceProxy,
        ApiServiceProxies.DynamicDataServiceProxy,
        ApiServiceProxies.StreamlineaSettingsServiceProxy,
        ApiServiceProxies.PaymentDashboardServiceProxy,
        ApiServiceProxies.ApAgingServiceProxy,
        ApiServiceProxies.ScheduledPaymentsServiceProxy,
        ApiServiceProxies.LocationServiceProxy,
        ApiServiceProxies.PaymentTemplatesCalendarServiceProxy,
        ApiServiceProxies.OneTimePaymentsServiceProxy,
        ApiServiceProxies.VendorServiceProxy,
        ApiServiceProxies.PayGroupServiceProxy,
        ApiServiceProxies.VendorClassServiceProxy,
        ApiServiceProxies.LegalEntityServiceProxy,
        ApiServiceProxies.PaymentTemplatesServiceProxy,
        ApiServiceProxies.BankAccountServiceProxy,
        ApiServiceProxies.PaymentMethodServiceProxy,
        ApiServiceProxies.DynamicRoleServiceProxy,
        ApiServiceProxies.DynamicPermissionServiceProxy,
        ApiServiceProxies.AccountEntriesServiceProxy,
        ApiServiceProxies.AccountsServiceProxy,
        ApiServiceProxies.AllocationsServiceProxy,
        ApiServiceProxies.DepartmentsServiceProxy,
        ApiServiceProxies.ViewHistoryServiceProxy,
        ApiServiceProxies.SyncPaymentsServiceProxy,
        ApiServiceProxies.ExportPaymentsServiceProxy,
        ApiServiceProxies.ApprovePaymentsServiceProxy,
        ApiServiceProxies.UndoLastImportServiceProxy,
        ApiServiceProxies.SelectPaymentsServiceProxy,
        ApiServiceProxies.DisbursementDetailsServiceProxy,
        ApiServiceProxies.ClientAndLocationServiceProxy,
        ApiServiceProxies.GridStateServiceProxy,
        ApiServiceProxies.AuditLogServiceProxy,
        ApiServiceProxies.CachingServiceProxy,
        ApiServiceProxies.ChatServiceProxy,
        ApiServiceProxies.CommonLookupServiceProxy,
        ApiServiceProxies.EditionServiceProxy,
        ApiServiceProxies.FriendshipServiceProxy,
        ApiServiceProxies.HostSettingsServiceProxy,
        ApiServiceProxies.InstallServiceProxy,
        ApiServiceProxies.LanguageServiceProxy,
        ApiServiceProxies.NotificationServiceProxy,
        ApiServiceProxies.OrganizationUnitServiceProxy,
        ApiServiceProxies.PermissionServiceProxy,
        ApiServiceProxies.ProfileServiceProxy,
        ApiServiceProxies.RoleServiceProxy,
        ApiServiceProxies.SessionServiceProxy,
        ApiServiceProxies.TenantServiceProxy,
        ApiServiceProxies.TenantDashboardServiceProxy,
        ApiServiceProxies.TenantSettingsServiceProxy,
        ApiServiceProxies.TimingServiceProxy,
        ApiServiceProxies.UserServiceProxy,
        ApiServiceProxies.UserLinkServiceProxy,
        ApiServiceProxies.UserLoginServiceProxy,
        ApiServiceProxies.WebLogServiceProxy,
        ApiServiceProxies.AccountServiceProxy,
        ApiServiceProxies.TokenAuthServiceProxy,
        ApiServiceProxies.TenantRegistrationServiceProxy,
        ApiServiceProxies.HostDashboardServiceProxy,
        ApiServiceProxies.PaymentServiceProxy,
        ApiServiceProxies.DemoUiComponentsServiceProxy,
        ApiServiceProxies.InvoiceServiceProxy,
        ApiServiceProxies.SubscriptionServiceProxy,
        ApiServiceProxies.InstallServiceProxy,
        ApiServiceProxies.UiCustomizationSettingsServiceProxy,
        ApiServiceProxies.PayPalPaymentServiceProxy,
        ApiServiceProxies.StripePaymentServiceProxy,
        ApiServiceProxies.DashboardCustomizationServiceProxy,
        ApiServiceProxies.WebhookEventServiceProxy,
        ApiServiceProxies.WebhookSubscriptionServiceProxy,
        ApiServiceProxies.WebhookSendAttemptServiceProxy,
        ApiServiceProxies.UserDelegationServiceProxy,
        ApiServiceProxies.DynamicPropertyServiceProxy,
        ApiServiceProxies.DynamicEntityPropertyDefinitionServiceProxy,
        ApiServiceProxies.DynamicEntityPropertyServiceProxy,
        ApiServiceProxies.DynamicPropertyValueServiceProxy,
        ApiServiceProxies.DynamicEntityPropertyValueServiceProxy,
        ApiServiceProxies.DomainServiceProxy,
        ApiServiceProxies.TwitterServiceProxy,
        { provide: RefreshTokenService, useClass: ZeroRefreshTokenService },
        { provide: AbpHttpConfigurationService, useClass: ZeroTemplateHttpConfigurationService },
        { provide: HTTP_INTERCEPTORS, useClass: AbpHttpInterceptor, multi: true }
    ]
})
export class ServiceProxyModule { }
